import { Box, Text } from '@medely/ui-kit';
import React from 'react';

export const CompensationModalInfo = () => {
  return (
    <>
      <Box pb={2} testId="compensation-modal">
        <Text size="l" textAlign="justify">
          Assignments are paid via weekly automatic direct deposits to your bank account. Weekly pay
          estimate is based on the projected hours listed in the assignment details. Actual hours
          may vary based on facility needs and may impact the overall weekly rate.
        </Text>
      </Box>
      <Text size="l" textAlign="justify">
        Earnings are automatically calculated on a weekly cycle, which normally begin at 12am PT on
        Sunday and end at 11:59pm PT the following Saturday.
      </Text>
    </>
  );
};
